<template>
    <div v-if="show" :class="['gradient-banner', 'compensation-banner', {'impossible': impossible}]">
        <div v-if="firstStep">
            <div v-if="!impossible" class="bunner-title">
                {{ $t('f_possible_compensation') }}
            </div>
            <!-- f_currency_symbol -->
            <div v-if="!impossible" class="sum">
                {{ totalCompensation }} {{ currencySymbol }}
            </div>
            <div v-else class="sum-0">
                {{ $t('f_0_compensation') }}
            </div>
            <div v-if="!impossible" class="per-person">
                {{ compensation_amount }} {{ currencySymbol }} {{ $t('f_per_person') }}
            </div>
            <div v-if="!impossible" class="extra-cost">
                {{ $t('f_extra_cost') }}
                <info-tip
                    regular="true"
                    :text="$t('f_extra_cost_tip_text')" />
            </div>
            <div v-if="!impossible && canadianRules" class="which_rules">
                {{ $t('f_banner_notification_canadian_max_compensation') }}
            </div>
            <div v-else-if="!impossible && euRules" class="which_rules">
                {{ $t('f_banner_notification_eu_max_compensation') }}
            </div>
            <div v-else-if="!impossible && britishRules" class="which_rules">
                {{ $t('f_banner_notification_gb_max_compensation') }}
            </div>
        </div>
        <div v-if="secondStep">
            <!--  /*-------------- NO COMPENSATION AT ALL -----------------*/-->

            <div v-if="!firstStep && noCompensationAtAll" class="sum-0">
                {{ $t('f_0_compensation') }}
            </div>

            <!-- /*-------------- REFUND ONLY ----------------------------*/

      compensable = true
      impossible = false
      compensation = 0
   -->
            <div v-if="!firstStep && refundOnly">
                <div v-if="!impossible && refundOnly" class="which_rules">
                    {{ $t('f_no_comp_but_refund') }}
                </div>
            </div>
        </div>
        <div v-if="thirdStep && notCompensable">
            <div class="sum-0">
                {{ $t('f_0_compensation') }}
            </div>
        </div>
        <!-- 
      /*-------------- COMPENSATION ONLY ----------------------*/

      compensable = true
      impossible = false
      compensation = X
      rules
   -->
        <div v-if="!firstStep && !thirdStep && compensationOnly ">
            <div v-if="!impossible" class="bunner-title">
                {{ $t('f_possible_compensation') }}
            </div>
            <!-- f_currency_symbol -->
            <div v-if="!impossible" class="sum">
                {{ totalCompensation }} {{ currencySymbol }}
            </div>
            <div v-else class="sum-0">
                {{ $t('f_0_compensation') }}
            </div>
            <div v-if="!impossible" class="per-person">
                {{ compensation_amount }} {{ currencySymbol }} {{ $t('f_per_person') }}
            </div>
            <div v-if="!impossible" class="extra-cost">
                {{ $t('f_extra_cost') }}
                <info-tip
                    regular="true"
                    :text="$t('f_extra_cost_tip_text')" />
            </div>
            <div v-if="!impossible && canadianRules" class="which_rules">
                {{ $t('f_banner_notification_canadian_max_compensation') }}
            </div>
            <div v-else-if="!impossible && euRules" class="which_rules">
                {{ $t('f_banner_notification_eu_max_compensation') }}
            </div>
            <div v-else-if="!impossible && britishRules" class="which_rules">
                {{ $t('f_banner_notification_gb_max_compensation') }}
            </div>
        </div>

        <!-- /*-------------- REFUND PLUS COMPENSATION ---------------*/

      compensable = true
      impossible = false
      compensation = X (may be 0)
      rules
      refund
   -->
        <div v-if="!firstStep && !thirdStep && refundPlusCompensation">
            <div v-if="!impossible" class="bunner-title">
                {{ $t('f_possible_compensation') }}
            </div>
            <!-- f_currency_symbol -->
            <div v-if="!impossible" class="sum">
                {{ totalCompensation }} {{ currencySymbol }}
            </div>
            <div v-else class="sum-0">
                {{ $t('f_0_compensation') }}
            </div>
            <div v-if="!impossible" class="per-person">
                {{ compensation_amount }} {{ currencySymbol }} {{ $t('f_per_person') }}
            </div>
            <div v-if="!impossible" class="extra-cost">
                {{ $t('f_extra_cost') }}
                <info-tip
                    regular="true"
                    :text="$t('f_extra_cost_tip_text')" />
            </div>


            <div v-if="!impossible && refundPlusCompensation" class="which_rules">
                {{ $t('f_comp_and_refund') }}
            </div>
            <div v-if="!impossible && canadianRules" class="which_rules">
                {{ $t('f_banner_notification_canadian_max_compensation') }}
            </div>
            <div v-else-if="!impossible && euRules" class="which_rules">
                {{ $t('f_banner_notification_eu_max_compensation') }}
            </div>
            <div v-else-if="!impossible && britishRules" class="which_rules">
                {{ $t('f_banner_notification_gb_max_compensation') }}
            </div>
        </div>
    </div>


    <div v-else-if="impossible && false" style="text-align: center; margin-top: 15px;">
        <!-- Delete false to show backend errors -->
        <div v-for="(error, index) of compensation_errors" :key="index" class="color-orange">
            <div v-for="(e, i) of error" :key="i">
                - {{ e }}
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'

  const {mapFields} = createHelpers({
    getterType: 'round1/getField',
    mutationType: 'round1/updateField'
  })

  export default {
    computed: {
      ...mapGetters({
        totalCompensation: 'round1/totalCompensation',
        currencySymbol: 'round1/currencySymbol',
      }),
      ...mapFields({
        compensation_amount: 'compensation.amount',
        compensation_errors: 'compensation.errors',
        compensation_type: 'compensation.compensation_type',
        compensable: 'compensation.compensable',
        law: 'compensation.which_law',
        step: 'step',
      }),
      impossible(){
        return (this.step == 1 && this.compensation_amount == 0) || ( this.step != 1 && (this.compensation_type == 0  || (this.compensation_type == 1 && this.compensation_amount == 0)))
      },
      firstStep() {
        return this.step == 1
      },
      secondStep() {
        return this.step == 2
      },
      thirdStep() {
        return this.step == 3
      },
      show() {
        return ((this.step == 1 && this.compensation_amount != 0) || this.step == 2 || (this.step == 3 && !this.compensable))
      },
      canadianRules() {
        return (this.law == "CAD")
      },
      euRules() {
        return (this.law == "EUR")
      },
      britishRules() {
        return (this.law == "GBP")
      },
      notCompensable() {
        return this.compensable == false
      },
      noCompensationAtAll() {
        return this.compensation_type == 0;
      },
      refundOnly() {
        return this.compensation_type == 2;
      },
      refundPlusCompensation() {
        return this.compensation_type == 3;
      },
      compensationOnly() {
        return this.compensation_type == 1;
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .gradient-banner.compensation-banner {
    &.impossible{
      padding: 45px 25px;
    }

    .info {
      z-index: 3;
      top: 10px;
      float: right;
    }

    .info-tip.bottom {
      .content {
        html.tablet &, html.desktop & {
          right: 0;
          top: 47px;
          left: auto;
        }
      }
    }

    .bunner-title {
      font-size: 16px;
      font-weight: 400;
      position: relative;
      width: fit-content;
      margin: auto;
      margin-bottom: 20px;

    }

    .sum {
      color: $orange_new;
      text-align: center;
    }

    .sum {
      font-size: 50px;
      font-weight: 500;
    }

    .sum-0 {
      // font-weight: 400;
      color: white;
      text-align: center;
    }

    .per-person {
      text-align: center;
      color: white;
      font-weight: 400;
    }

    .extra-cost {
      color: $orange_new;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;

      .info-tip {
        > .icon {
          color: #949494;
        }

        .icon-thin-info {
          &:after {
            html.tablet &, html.desktop & {
              top: -10px;
              right: -2px;
            }
          }
        }

        .content {
          bottom: 42px;
          top: auto !important;

          html.tablet &, html.desktop & {
            top: auto;
          }
        }
      }
    }
    .which_rules {
      color: white;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      margin-bottom: 20px;
    }
  }
</style>
